<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import {
  splitLocalDateTime,
  toIsoDateTime,
} from '../helper/dateRangeFilterHelper';

const props = defineProps({
  modelValue: {
    type: Object,
    default: () => ({ from: '', to: '' }),
  },
});

const emit = defineEmits(['update:modelValue']);
const { t } = useI18n();

const parseDateTime = splitLocalDateTime;

// "To" without an explicit time means the end of that day, so "between 14.09
// and 21.09" includes the 21st.
const combineDateTime = (key, date, time) =>
  toIsoDateTime(date, time, key === 'to' ? '23:59:59' : '00:00');

const rangeValue = computed(() => ({
  from: props.modelValue?.from || '',
  to: props.modelValue?.to || '',
}));

const updateRange = (key, date, time) => {
  emit('update:modelValue', {
    ...rangeValue.value,
    [key]: combineDateTime(key, date, time),
  });
};

const fromDate = computed({
  get: () => parseDateTime(rangeValue.value.from).date,
  set: value => {
    const { time } = parseDateTime(rangeValue.value.from);
    updateRange('from', value, time);
  },
});

const fromTime = computed({
  get: () => parseDateTime(rangeValue.value.from).time,
  set: value => {
    const { date } = parseDateTime(rangeValue.value.from);
    updateRange('from', date, value);
  },
});

const toDate = computed({
  get: () => parseDateTime(rangeValue.value.to).date,
  set: value => {
    const { time } = parseDateTime(rangeValue.value.to);
    updateRange('to', value, time);
  },
});

const toTime = computed({
  get: () => parseDateTime(rangeValue.value.to).time,
  set: value => {
    const { date } = parseDateTime(rangeValue.value.to);
    updateRange('to', date, value);
  },
});
</script>

<template>
  <div class="flex min-w-0 flex-1 flex-wrap items-center gap-1.5">
    <span class="shrink-0 text-xs text-n-slate-11">
      {{ t('FILTER.OPERATOR_LABELS.is_from') }}
    </span>
    <input
      v-model="fromDate"
      type="date"
      class="block min-w-0 flex-1 h-8 py-1.5 px-2 text-sm reset-base outline outline-1 outline-n-weak rounded-lg bg-n-alpha-black2 text-n-slate-12"
    />
    <input
      v-model="fromTime"
      type="time"
      class="block w-24 shrink-0 h-8 py-1.5 px-2 text-sm reset-base outline outline-1 outline-n-weak rounded-lg bg-n-alpha-black2 text-n-slate-12"
    />
    <span class="shrink-0 text-xs text-n-slate-11">
      {{ t('FILTER.OPERATOR_LABELS.is_to') }}
    </span>
    <input
      v-model="toDate"
      type="date"
      class="block min-w-0 flex-1 h-8 py-1.5 px-2 text-sm reset-base outline outline-1 outline-n-weak rounded-lg bg-n-alpha-black2 text-n-slate-12"
    />
    <input
      v-model="toTime"
      type="time"
      class="block w-24 shrink-0 h-8 py-1.5 px-2 text-sm reset-base outline outline-1 outline-n-weak rounded-lg bg-n-alpha-black2 text-n-slate-12"
    />
  </div>
</template>
